/** @format */

/**
 * 3段階閾値
 * @param {number} value 値
 * @param {string} type 種別
 */
const getLevel = (value, type = "ratio") => {
  const threshold = {
    ratio: [40, 70],
  };
  if (!threshold[type]) {
    type = "ratio";
  }
  if (value < threshold[type][0]) {
    return 1;
  } else if (value >= threshold[type][1]) {
    return 3;
  } else {
    return 2;
  }
};

/**
 * XorShift 疑似乱数
 */
class Random {
  /**
   * XorShift初期化
   * @param {number} seed シード値
   */
  constructor(seed = 88675126) {
    this.x = 123456789;
    this.y = 362436069;
    this.z = 521288629;
    this.w = seed;
  }

  /**
   * 乱数生成
   */
  next() {
    let t = this.x ^ (this.x << 11);
    this.x = this.y;
    this.y = this.z;
    this.z = this.w;
    return Math.abs((this.w = this.w ^ (this.w >>> 19) ^ (t ^ (t >>> 8))));
  }
}

export { getLevel, Random };
